import { TPointAssignee } from 'react-lib/components/molecules/PointAssignees';
import { TAllUsers, TWorkspaceUser } from '@project/view-models';

type TBuildPointAssigneesOptions = {
  assigneeIds: string[];
  workspaceUserIds: string[];
  users: TAllUsers;
};

export type TPointAssigneeLists = {
  selected: TPointAssignee[];
  options: TPointAssignee[];
};

const byLabel = (a: TPointAssignee, b: TPointAssignee): number =>
  a.label.toLowerCase().localeCompare(b.label.toLowerCase());

const toAssignee = (user: TWorkspaceUser): TPointAssignee => ({
  value: user.userId,
  label: user.userName,
  avatarUrl: user.avatarPublicUrl,
});

const knownUsers = (ids: string[], users: TAllUsers): TWorkspaceUser[] =>
  ids.map((id) => users[id]).filter((user): user is TWorkspaceUser => user !== undefined);

export const buildPointAssignees = ({
  assigneeIds,
  workspaceUserIds,
  users,
}: TBuildPointAssigneesOptions): TPointAssigneeLists => ({
  selected: knownUsers(assigneeIds, users).map(toAssignee).sort(byLabel),
  options: knownUsers(workspaceUserIds, users)
    .filter((user) => user.verified === true)
    .map(toAssignee)
    .sort(byLabel),
});
